import { Table, Form, Input, Popconfirm,Space,Button} from "antd";
import { useEffect,useState,useRef } from "react";
import {
  GetAllClientCreds,
  GetClientLoginUrl,
  UpdateClientCredential,
} from "../../Repository/ClientCredentialsRepository";
import {
  EditOutlined,
  SearchOutlined,
  CloseOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { SuccessMessage } from "../../Utils/Utils";
import '../GridCredentialUpdate/GridCredentialUpdate.css';

// EditableCell component for inline editing
const EditableCell = ({ dataIndex, children, editing, onSave, ...restProps }) => {
  const inputRef = useRef();

  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const handleSave = async () => {
    try {
      await onSave();
    } catch (error) {
      console.error("Error saving user:", error);
    }
  };

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `Please enter ${dataIndex}!`,
            },
          ]}
        >
          <Input
            ref={inputRef}
            onPressEnter={handleSave}
            // onBlur={handleSave}
          />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};



const GridCredentialUpdate = () => {
  const [loading, setLoading] = useState(true);
  const [EditingRecord, setEditingRecord] = useState(null);
  const IsRecordInEditingState = (Id) => Id === EditingRecord;
  const [clientsData, setClientsData] = useState([]);
  const [form] = Form.useForm();
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState("")
  
  // Fetch All clients data on component mount
  useEffect(() => {
    const fetchData = async () => {
      const clientsData = await GetAllClientCreds();
      if (clientsData) {
        setClientsData(clientsData);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {

    // confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = async (clearFilters) => {
    clearFilters();
    setSearchText("");
    let Data = await GetAllClientCreds();
    console.log(Data);
    setClientsData(Data);
  };
  const getColumnSearchProps = (dataIndex, placeholder) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space> <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>),filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    filteredValue: [searchText],
    onFilter: (value, record) => {
      const clientName = record && record.Client_Name;
      return clientName && String(clientName).toLowerCase().includes(value.toLowerCase());
    
    
  },

  });
  // Columns configuration for the user table
  const UserTableColumns = [
    {
      title: "Vms Name",
      dataIndex: "VMS",
      sorter: (a, b) => a.VMS.localeCompare(b.VMS),
      onFilter: (value, record) => record.VMS.indexOf(value) === 0,
      width: "9%"
    },
    {
      title: "Client Name",
      dataIndex: "Client_Name",
      width: "17%",
      sorter: (a, b) => a.Client_Name.localeCompare(b.Client_Name),
      sortDirections: ["descend", "ascend"],
      ...getColumnSearchProps("Client_Name", "Search Client Name"),
    },
    
    {
      title: "User Name",
      dataIndex: "portal_username",
      editable: true,
      width: "16%",
    },
    {
      title: "Password",
      dataIndex: "portal_password",
      editable: true,
      width: "9%",
      render: (_, record) => {
        return (
          <EditableCell
            dataIndex={`portal_password_${record.Id}`}
            editing={IsRecordInEditingState(record.Id)}
          >
            {IsRecordInEditingState(record.Id) ? null : "********"}
          </EditableCell>
        );
      },
    },
    {
      title: "Portal",
      width: "17%",
      dataIndex: "url",
      render: (_, record) => {
        return (
          <a onClick={()=>handleSourceLinkClick(record)} rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>
           {record.Client_Name}
          </a>
        );
      },
    },
  ];

  const MergedColumns = UserTableColumns.map((column) => {
    if (column.editable) {
      return {
        ...column,
        onCell: (record) => ({
          record,
          dataIndex: column.dataIndex,
          title: column.title,
          editing: IsRecordInEditingState(record.Id),
          onSave: () => SaveUser(record), 
          form,
        
        }),
      };
    }
    return column;
  });
  
  const handleSourceLinkClick = async (record) =>{
    const Response = await GetClientLoginUrl(record);
    if(Response != null){
      window.open(Response, '_blank');
      // window.open(Response, '_blank', 'width=800,height=600')
    }
  }
  const onRowDoubleClick = (record) => {
    if (!IsRecordInEditingState(record.Id)) {
      EditUser(record);
    }
    else{
      CancelEditing();
    }
  };

  const EditUser = (record) => {
    form.setFieldsValue({ ...record });
    setEditingRecord(record.Id);
  };

  const CancelEditing = () => {
    setEditingRecord(null);
  };
  const SaveUser = async () => {
    try {
      const formData = form.getFieldValue();  
      const Response = await UpdateClientCredential(formData);
  
      if (Response != null) {
        setEditingRecord(null);
        SuccessMessage(Response.message);
        setClientsData(await GetAllClientCreds());
      }
    } catch (error) {
      console.error("Error saving user:", error);
    }
  };

  // Map and transform data for the table
  const data =
  clientsData && clientsData.length > 0
    ? clientsData.map((client) => ({
        Id: client.Id,
        VMS: client.VMS,
        Payroll: client.Payroll,
        Client_Name: client.Client_Name,
        portal_username: client.portal_username,
        portal_password: client.portal_password,
      }))
    : [];
 
 

  return (
    
    <Form form={form} component={false}>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        columns={MergedColumns}
        loading={loading}
        dataSource={data}
        scroll={{ y: 470 }}
        pagination={false}
        className="grid-table"
        onRow={(record, rowIndex) => ({
          onDoubleClick: () => onRowDoubleClick(record),
        })}
      />
    </Form>
  );
};

export default GridCredentialUpdate;
